import { render } from "./chart2.vue?vue&type=template&id=3b50a450&ts=true"
import script from "./chart2.vue?vue&type=script&lang=ts"
export * from "./chart2.vue?vue&type=script&lang=ts"

import "./chart2.vue?vue&type=style&index=0&id=3b50a450&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__